import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps, OrderStatus} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useDeliveryOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, OrderStatus.delivering);

  return useApiMutation({
    url: `/orders/${orderId}/delivering`,
    method: 'PATCH',
    errorTitle: 'Erro ao colocar pedido em entrega',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido em entrega!',
    onSuccess,
  });
};

export default useDeliveryOrder;
